<template>
  <div class="gp-login">
    <div class="gp-login-card">
      <div class="card-body">
        <div class="row text-center mb-3">
          <div class="col-md-12">
            <img src="/images/logogarantepay.jpg" class="gp-login-logo" alt="Logo" />
          </div>
        </div>
       
        <!-- Formulário de login -->
        <div class="form-group">
          <h3 class="fw-bold mb-3">Atualizar Senha</h3>
          <label for="user">Digite sua nova senha</label>
          <div class="input-icon">
            <input v-model="senhaNova1" type="password" class="form-control" @keyup.enter.prevent="validaUser()" />
            <span class="input-icon-addon">
              <i class="fa fa-lock"></i>
            </span>
          </div>
        </div>
        <div class="form-group">
          <label for="senha">Repita a nova senha</label>
          <div class="input-icon">
            <input v-model="senhaNova2" type="password" class="form-control" @keyup.enter.prevent="validaUser()" />
            <span class="input-icon-addon">
              <i class="fa fa-lock"></i>
            </span>
          </div>
        </div>
        
        <div class="row mb-3">
          <div class="col-md-12 text-center">
            <button class="btn btn-primary btn-block" style="width: 100%;" @click="AtualizaSenha()">Atualizar senha</button>
          </div>
        </div>
        
        <div class="row mb-3">
          <div class="col-md-12 text-right">
            <a href="https://garantepay.net.br" class="btn btn-link">ir para login</a>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { SHA256 } from 'crypto-js';
import { useRoute } from 'vue-router';

export default {
  name: 'ResetSenhaView',
  setup() {
    const route = useRoute();
    const id = route.params.id;
    const key = route.params.key;
    return {
      id, key
    };
  },
  components: {
    moment
  },
  data: () => ({
    id: '',
    senhaNova1: '',
    senhaNova2: '',
    User: [],
  }),
  methods: {
    AtualizaSenha() {
      if (this.senhaNova1 != this.senhaNova2) {
        this.$mensagemErro('Senha não são iguais.');
      } else {
        let _dados = {
          cusId: parseInt(this.id),
          cusNome: this.User.cusNome,
          cusEmail: this.User.cusEmail,
          cusTelefone: this.User.cusTelefone,
          cusWhatsapp: this.User.cusWhatsapp,
          cusUrlImagem: this.User.cusUrlImagem,
          cliId:this.User.cliId,
          garId: this.User.garId,
          tpeId:this.User.tpeId,
          pesId:this.User.pesId,
          cusSenha: this.senhaNova1,
          tusId: this.User.admTipoUsuario.tusId,
          cusAtivo: this.User.cusAtivo
        }
        axios.put(`/Process/UsrCadastroUsuarios/Update`, _dados)
          .then(response => {
            if (response.status == 200) {
            this.EnviaEmail(this.User.cusNome, this.User.cusEmail)
            }
          });
      }

    },
    EnviaEmail(_nomePara, _destinatario,_dados){
              axios.get(`/Process/CadMensagensPadrao/GetAll`)
                      .then(response => {
                        this.templateEmail = response.data.filter(x=> x.mpdId == 13);
                               let _dadosEmail = {
                                            nomeDe: this.$GarantePayNome,
                                            nomePara: _nomePara,
                                            assunto: 'Reset de senha concluído - Sistema GarantePay',
                                            destinatario: _destinatario,
                                            emailResposta: this.$GarantePayEmail,
                                            textoEmail: this.templateEmail[0].mpdTexto
                                                        .replace('[Logo]', '<center><img src="https://garantepay.net.br/images/logogarantepay.jpg" style="width: 200px;" /></center>'),
                                            listAnexos: null //{nomeAnexo: '', anexo: '', tipoAnexo: ''}
                                        }
                                axios.post(`/Process/AdmControleSmtp/Enviamail`,_dadosEmail)
                                  .then(response => {
                                        if (response.data == 1){
                                          this.$mensagemSucesso("Reset de senha concluído!");
                                          this.senhaNova1 = "";
                                          this.senhaNova2 = "";
                                        }
                                 });
                      });
    },
  },
  created() {
    if (this.id) {
      const param1 = this.id;
      const param2 = this.key;

      axios.get(`/Process/UsrCadastroUsuarios/GetById/${param1}`)
        .then(response => {
          this.User = response.data;
          console.log(' this.User')
          console.log( this.User)
          const originalHash = param2;

          const valueToCompare = this.User.cusEmail;
          const compareHash = SHA256(valueToCompare).toString();
          if (originalHash != compareHash) {
            this.$mensagemErro("Não é possível resetar senha, contato administrador.")
            this.$router.push('/')
          }
        });
    }
  }
}
</script>

<style>
.v-card-actions {
  align-items: center;
  display: flex;
  flex: none;
  min-height: 52px;
  padding: 0.5rem;
  padding-right: 20px !important;
}
</style>
